import { render, staticRenderFns } from "./Inquire.vue?vue&type=template&id=f1f2fdc8&scoped=true&"
import script from "./Inquire.vue?vue&type=script&lang=js&"
export * from "./Inquire.vue?vue&type=script&lang=js&"
import style0 from "./Inquire.vue?vue&type=style&index=0&id=f1f2fdc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1f2fdc8",
  null
  
)

component.options.__file = "Inquire.vue"
export default component.exports